import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ARComponent } from './ar.component';
import { ArFeeCalculationComponent } from './fee-calculation/ar-fee-calculation/ar-fee-calculation.component';
import { ArLedgerComponent } from './ledger/ar-ledger/ar-ledger.component';
import { ArPaymentComponent } from './payment/ar-payment/ar-payment.component';
import { ClaimManagementComponent } from './claims/claim-management/claim-management.component';

const routes: Routes = [{
  path: '', component: ARComponent,
  children: [
    { path: 'feeCalculation', component: ArFeeCalculationComponent },
    { path: 'insuranceClaims', component: ClaimManagementComponent },
    { path: 'ledger', component: ArLedgerComponent },
    { path: 'payment', component: ArPaymentComponent },
    // 'landing/insurance-payment' removed: ArInsurancePaymentComponent is dialog-only and must
    // be opened via MatDialog (see tdo-smartnav / scheduler-subnav), not routed to as a page.
    // { path: 'wp/paymentReturn', component: ArWorldpayPaymentReturnComponent },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ARRoutingModule { }
